/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { JoinEntityDto } from './join-entity-dto';
import { PermissionDto } from './permission-dto';
 /**
 *
 *
 * @export
 * @interface AuthorityDto
 */
export interface AuthorityDto {

    /**
     * Unique identifier
     *
     * @type {number}
     * @memberof AuthorityDto
     * @example 1
     */
    id: number;

    /**
     * Creation timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof AuthorityDto
     * @example 2024-01-15T10:30:00.000Z
     */
    created: string;

    /**
     * Last update timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof AuthorityDto
     * @example 2024-06-01T08:00:00.000Z
     */
    updated: string;

    /**
     * Soft-delete timestamp — null when the record is active
     *
     * @type {string}
     * @memberof AuthorityDto
     */
    deleted: string | null;

    /**
     * @type {string}
     * @memberof AuthorityDto
     */
    name: string;

    /**
     * @type {string}
     * @memberof AuthorityDto
     */
    description: string;

    /**
     * @type {Array<PermissionDto>}
     * @memberof AuthorityDto
     */
    permissions: Array<PermissionDto>;

    /**
     * @type {JoinEntityDto}
     * @memberof AuthorityDto
     */
    client: JoinEntityDto;
}
